"use strict";

exports.__esModule = true;
var _DeviceInfo = require("./DeviceInfo");
Object.keys(_DeviceInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceInfo[key]) return;
  exports[key] = _DeviceInfo[key];
});